<template>
  <v-card>
    <v-card-title>
      Mesas y Cuentas
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        small
        :loading="isLoading"
        :disabled="isLoading"
        @click="loadData"
      >
        <v-icon left>mdi-refresh</v-icon>
        Recargar
      </v-btn>
    </v-card-title>
    <v-card-text>
      <div v-if="isLoading" class="text-center pa-10">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
        ></v-progress-circular>
        <p class="mt-4">Cargando datos de todos los departamentos...</p>
      </div>

      <div v-else-if="deptosConDatos.length > 0">
        <v-card
          v-for="depto in deptosConDatos"
          :key="depto.Id"
          class="mb-4"
          outlined
        >
          <v-card-title class="primary white--text">
            {{ depto.Nombre }}
          </v-card-title>
          <v-card-text class="pa-0">
            <v-expansion-panels multiple>
              <v-expansion-panel
                v-for="area in depto.areasAgrupadas"
                :key="area.nombre"
              >
                <v-expansion-panel-header
                  class="font-weight-medium grey lighten-3"
                >
                  {{ area.nombre }} - {{ area.mesas.length }} mesa(s)
                </v-expansion-panel-header>

                <v-expansion-panel-content class="py-2 grey lighten-3">
                  <v-expansion-panels multiple>
                    <v-expansion-panel
                      v-for="mesa in area.mesas"
                      :key="mesa.Contenedor.Id"
                      :color="
                        mesa.Cuentas.length === 0
                          ? 'red lighten-5'
                          : 'blue-grey lighten-5'
                      "
                    >
                      <v-expansion-panel-header>
                        {{ mesa.Contenedor.Nombre }} -
                        {{
                          mesa.Cuentas.length > 0
                            ? mesa.Cuentas.length + " cuenta(s)"
                            : "Sin cuentas"
                        }}
                        <v-spacer></v-spacer>
                        <v-btn
                          color="error"
                          small
                          class="mr-2"
                          style="max-width: fit-content"
                          @click.stop="cerrarMesa(mesa, depto.Id)"
                        >
                          Cerrar mesa</v-btn
                        >
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div v-if="mesa.Cuentas.length > 0">
                          <h3>Cuentas en la mesa</h3>
                          <v-simple-table>
                            <thead>
                              <tr>
                                <td>ID Cuenta</td>
                                <td>Cliente</td>
                                <td>Apodo</td>
                                <td>Mesero</td>
                                <td>Estatus</td>
                                <td>Comensales</td>
                                <td>Acciones</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="cuenta in mesa.Cuentas"
                                :key="cuenta.id"
                              >
                                <td>{{ cuenta.id }}</td>
                                <td>
                                  {{
                                    cuenta.Cliente ? cuenta.Cliente.Nombre : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    cuenta.Cliente ? cuenta.Cliente.Apodo : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    cuenta.Mesero ? cuenta.Mesero.Nombre : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    cuenta.Estatus == 1 ? "Abierta" : "Cerrada"
                                  }}
                                </td>
                                <td class="text-center">
                                  {{ cuenta.Comensales }}
                                </td>
                                <td>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        color="primary"
                                        class="mx-2"
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="abrirModalMesero(cuenta)"
                                      >
                                        <v-icon>mdi-account-edit</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Cambiar Mesero</span>
                                  </v-tooltip>

                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        color="success"
                                        class="mx-2"
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="abrirModalMesa(cuenta)"
                                      >
                                        <v-icon>mdi-swap-horizontal</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Cambiar Mesa</span>
                                  </v-tooltip>

                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        color="warning"
                                        class="mx-2"
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="abrirModalCliente(cuenta)"
                                      >
                                        <v-icon
                                          >mdi-account-convert-outline</v-icon
                                        >
                                      </v-btn>
                                    </template>
                                    <span>Cambiar Cliente</span>
                                  </v-tooltip>

                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        color="info"
                                        class="mx-2"
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="abrirModalComensales(cuenta)"
                                      >
                                        <v-icon>mdi-pencil</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Editar Comensales</span>
                                  </v-tooltip>

                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        color="error"
                                        class="mx-2"
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="eliminarCuenta(cuenta)"
                                      >
                                        <v-icon>mdi-delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Desactivar Cuenta</span>
                                  </v-tooltip>
                                </td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </div>

                        <div v-else>
                          <p class="font-weight-bold text-center pa-2 ma-0">
                            Mesa abierta sin cuentas
                          </p>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </div>

      <div v-else class="text-center pa-10 grey--text">
        <v-icon size="50" class="mb-3">mdi-information-outline</v-icon>
        <p>No se encontraron mesas abiertas.</p>
      </div>
    </v-card-text>

    <v-dialog v-model="dialogs.dialogChangeMesero" persistent max-width="390">
      <v-card>
        <v-card-title> Cambiar Mesero </v-card-title>
        <v-card-text v-if="modelHelper.AYBTable">
          <!-- {{ modelHelper.AYBTable ? modelHelper.AYBTable.Mesero : "" }} -->
          <v-select
            v-if="modelHelper.AYBTable"
            v-model="modelHelper.AYBTable.Mesero"
            :items="meseros"
            label="Meseros Disponibles"
            item-value="Id"
            item-text="Nombre"
            return-object
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialogs.dialogChangeMesero = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" text @click="cambiarMesero()">
            Cambiar Mesero
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- cambio de mesa --->
    <v-dialog v-model="dialogs.dialogChangeMesa" persistent max-width="390">
      <v-card>
        <v-card-title> Cambiar Mesa </v-card-title>
        <v-card-text>
          <v-autocomplete
            :items="Areas"
            v-model="modelHelper.areaSelected"
            label="Área de Destino"
            item-text="Nombre"
            item-value="id"
            @change="loadMesasDisponibles"
          ></v-autocomplete>
          <v-select
            v-model="modelHelper.toMesa"
            :items="mesasDisponibles"
            label="Mesas Disponibles"
            item-value="id"
            item-text="Nombre"
            :disabled="!modelHelper.areaSelected"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialogs.dialogChangeMesa = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" text @click="cambiarMesa()">
            Cambiar de mesa
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- cambiar cliente de cuenta --->
    <v-dialog v-model="dialogs.dialogChangeCliente" persistent max-width="390">
      <v-card>
        <v-card-title class="headline">
          Cambiar cliente de cuenta
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            label="Cliente"
            v-model="modelHelper.selectedChangeClient"
            :items="comp_clients"
          ></v-autocomplete>
          <v-text-field
            label="Alias de cuenta"
            v-model="modelHelper.alias"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="dialogs.dialogChangeCliente = false"
          >
            Cancelar
          </v-btn>

          <v-btn color="green darken-1" text @click="changeClientAccount()">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- editar comensales de cuenta --->
    <v-dialog
      v-model="dialogs.dialogChangeComensales"
      max-width="390"
      title="Comensales"
    >
      <v-card>
        <v-card-title class="headline">
          Editar número de comensales
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="Número de Comensales"
            v-model="modelHelper.comensales.Cantidad"
            type="number"
            min="1"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="dialogs.dialogChangeComensales = false"
          >
            Cancelar
          </v-btn>

          <v-btn color="green darken-1" text @click="changeComensales()">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
      <!-- <ComensalesEditor
        v-if="dialogs.dialogChangeComensales"
        @onConfirm="onConfirmComensales"
        v-model="modelHelper.comensales.Cantidad"
        TextButton="Guardar"
        Description="Indica el numero de comensales"
      /> -->
    </v-dialog>
  </v-card>
</template>
<script>
export default {
  name: "MesasCuentasPorDeptoArea",
  data() {
    return {
      isLoading: false,
      departamentos: [],
      dataPorDepartamento: [],
      Areas: [],
      contenedoresDepto: [],
      mesasDisponibles: [],
      dialogs: {
        dialogChangeMesero: false,
        dialogChangeMesa: false,
        dialogChangeCliente: false,
        dialogChangeComensales: false,
      },
      meseros: [],
      modelHelper: {
        usedDepartment: null,
        AYBTable: null,
        areaSelected: null,
        toMesa: null,
        selectedChangeClient: null,
        alias: null,
        comensales: {
          Cantidad: 1,
          Id: null,
        },
      },
    };
  },
  computed: {
    deptosConDatos() {
      if (!this.dataPorDepartamento || this.dataPorDepartamento.length === 0) {
        return [];
      }
      return this.dataPorDepartamento.filter(
        (depto) => depto.areasAgrupadas && depto.areasAgrupadas.length > 0,
      );
    },
    comp_clients() {
      let rowclientes = this.$store.getters.getClientes;
      return rowclientes.map((cli) => ({
        ...cli,
        value: cli.id,
        text: `${cli.Apellidos} ${cli.Nombres}`,
      }));
    },
  },
  methods: {
    // inicio getData //
    async getDepartamentosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Departamentos",
        );
      if (snapshot.exists()) {
        this.departamentos = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.departamentos.push(toAdd);
          }
        });
      }
    },
    async getAreasByDepto(deptoId) {
      let Areas = [];
      const db = this.$store.getters.getFirebaseApp.database;
      const firestore = this.$store.getters.getFirebaseApp.firestore;

      const snapshotAreas = await db.queryBuilder(`AYB/Areas/${deptoId}`);
      if (snapshotAreas.exists()) {
        Object.keys(snapshotAreas.val()).forEach((id) => {
          const toAdd = snapshotAreas.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            toAdd.id = id;
            Areas.push(toAdd);
          }
        });
      }

      const dataMapas = await firestore.queryBuilder("AYB_Mapas", [
        firestore.where("Departamento", "==", deptoId),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant,
        ),
      ]);
      let mapas = dataMapas.docs.map((doc) => ({
        Id: doc.ref.id,
        ...doc.data(),
      }));

      Areas.forEach((area) => {
        const mapaEncontrado = mapas.find((mapa) => mapa.Area == area.Id);
        if (mapaEncontrado) {
          area.Mapa = mapaEncontrado;
        }
      });
      return Areas.filter((area) => area.Mapa);
    },
    async getContenedoresByDepto(deptoId) {
      let contenedores = [];
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          `AYB/Contenedores/${deptoId}`,
        );
      if (snapshot.exists()) {
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            toAdd.id = id;
            contenedores.push(toAdd);
          }
        });
      }
      return contenedores;
    },
    async getCuentasAbiertasByMesa(mesasAbiertas) {
      const cuentasPorMesa = {};
      const asociaciones = [];
      const idsUnicos = new Set();

      mesasAbiertas.forEach((mesa) => {
        const mesaKey = mesa.Contenedor.Id;
        cuentasPorMesa[mesaKey] = [];
        if (mesa.Contenedor.Estado && mesa.Contenedor.Estado.Cuentas) {
          Object.keys(mesa.Contenedor.Estado.Cuentas).forEach((cuentaId) => {
            asociaciones.push({ cuentaId, mesaKey });
            idsUnicos.add(cuentaId);
          });
        }
      });

      if (idsUnicos.size === 0) {
        return {};
      }

      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const idsArray = [...idsUnicos];
      const lotesDeIds = [];

      for (let i = 0; i < idsArray.length; i += 30) {
        lotesDeIds.push(idsArray.slice(i, i + 30));
      }

      const promesasConsultas = lotesDeIds.map((lote) =>
        firestore.queryBuilder("AYB_Cuentas", [
          firestore.where("__name__", "in", lote),
        ]),
      );

      try {
        const snapshotsPorLote = await Promise.all(promesasConsultas);

        const cuentasMap = new Map(
          snapshotsPorLote.flatMap((snapshot) =>
            snapshot.docs.map((doc) => {
              const cuenta = { id: doc.ref.id, ...doc.data() };
              return [cuenta.id, cuenta];
            }),
          ),
        );

        asociaciones.forEach(({ cuentaId, mesaKey }) => {
          const cuentaDoc = cuentasMap.get(cuentaId);
          if (cuentaDoc) {
            cuentasPorMesa[mesaKey].push(cuentaDoc);
          }
        });

        return cuentasPorMesa;
      } catch (error) {
        console.error("Error al buscar cuentas por lotes:", error);
        return {};
      }
    },

    async getMeserosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Meseros",
        );
      if (!snapshot.exists()) {
        this.meseros = [];
        return;
      }

      const allMeseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
      const filterId = this.modelHelper.usedDepartment;

      const filteredList = filterId
        ? allMeseros.filter(
            (m) => m.Deptos && Object.keys(m.Deptos).includes(filterId),
          )
        : allMeseros;

      this.meseros = filteredList.map((mesero) => {
        return {
          Nombre: mesero.Nombre,
          Id: mesero.id,
        };
      });
    },
    // fin getData //

    // inicio metodos modales //
    async abrirModalMesero(cuenta) {
      this.modelHelper.AYBTable = cuenta;
      this.modelHelper.usedDepartment = cuenta.DAYB;
      await this.getMeserosAB();
      this.dialogs.dialogChangeMesero = true;
    },
    async abrirModalMesa(cuenta) {
      this.modelHelper.AYBTable = cuenta; // Guarda la cuenta a mover
      this.modelHelper.usedDepartment = cuenta.DAYB;
      this.modelHelper.areaSelected = null;
      this.modelHelper.toMesa = null;
      this.mesasDisponibles = [];

      try {
        // Carga las áreas y contenedores del depto. de la cuenta
        this.Areas = await this.getAreasByDepto(
          this.modelHelper.usedDepartment,
        );
        this.contenedoresDepto = await this.getContenedoresByDepto(
          this.modelHelper.usedDepartment,
        );
        this.dialogs.dialogChangeMesa = true; // Abre el modal
      } catch (error) {
        console.error("Error al cargar datos para cambiar mesa:", error);
        this.$swal(
          "Error",
          "No se pudieron cargar las áreas y mesas disponibles.",
          "error",
        );
      }
    },
    async abrirModalCliente(cuenta) {
      // console.log(cuenta, "-", cuenta.Cliente.Id)
      this.modelHelper.AYBTable = cuenta;
      this.modelHelper.usedDepartment = cuenta.DAYB;
      this.modelHelper.selectedChangeClient = cuenta.Cliente.Id;
      this.modelHelper.alias = cuenta.Cliente.Apodo;
      this.dialogs.dialogChangeCliente = true;
    },
    abrirModalComensales(cuenta) {
      this.modelHelper.comensales.Cantidad = cuenta.Comensales
        ? cuenta.Comensales
        : 1;
      this.modelHelper.comensales.Id = cuenta.id;
      this.modelHelper.AYBTable = cuenta;
      console.log("comensales", this.modelHelper.comensales.Cantidad);
      this.dialogs.dialogChangeComensales = true;
    },
    //

    // inicio procesarData //
    processMesasAbiertas(areas, contenedores) {
      let abiertas = [];
      areas.forEach((area) => {
        if (!area.Mapa || !area.Mapa.Mapa) return;

        area.Mapa.Mapa.forEach((item) => {
          const contenedor = contenedores.find((c) => c.Id === item.id);

          if (contenedor && contenedor.Estado && contenedor.Estado.E == 1) {
            abiertas.push({
              Area: area.Nombre,
              Contenedor: contenedor,
            });
          }
        });
      });
      return abiertas;
    },
    getMesasYCuentas(mesasAbiertas, cuentasPorMesa) {
      return mesasAbiertas.map((mesa) => {
        const cuentas = cuentasPorMesa[mesa.Contenedor.Id] || [];
        return { ...mesa, Cuentas: cuentas };
      });
    },
    agruparMesasPorArea(mesasCompletas) {
      const mapaAreas = new Map();
      mesasCompletas.forEach((mesa) => {
        const nombreArea = mesa.Area;
        if (!mapaAreas.has(nombreArea)) {
          mapaAreas.set(nombreArea, []);
        }
        mapaAreas.get(nombreArea).push(mesa);
      });
      return Array.from(mapaAreas.entries()).map(([nombre, mesas]) => {
        return { nombre, mesas };
      });
    },
    loadMesasDisponibles(areaId) {
      this.modelHelper.toMesa = null;

      if (!areaId) {
        this.mesasDisponibles = [];
        return;
      }

      const area = this.Areas.find((a) => a.id === areaId);
      if (!area || !area.Mapa || !area.Mapa.Mapa) {
        this.mesasDisponibles = [];
        return;
      }

      const idsMesasEnArea = area.Mapa.Mapa.map((item) => item.id);

      this.mesasDisponibles = this.contenedoresDepto.filter((c) => {
        const estaEnArea = idsMesasEnArea.includes(c.id);
        // const estaDisponible = !c.Estado || c.Estado.E !== 1;
        return estaEnArea;
        // && estaDisponible
      });
    },
    // fin procesarData //

    // inicio metodos para mesas //
    async changeComensales() {
      const dataToSend = {
        IdCuenta: this.modelHelper.comensales.Id,
        Comensales: Number(this.modelHelper.comensales.Cantidad),
        Departamento: this.modelHelper.AYBTable.Departamento,
      };
      this.$alert.alertConfirm({
        action: "cambiar",
        obj: "los comensales de la cuenta",
        route: "AYB-Cuentas-cambiarComensales",
        data: dataToSend,
        onSuccess: () => {
          this.dialogs.dialogChangeComensales = false;
          this.loadData();
        },
      });
    },
    async changeClientAccount() {
      let datos = {
        IdCuenta: this.modelHelper.AYBTable.id,
        Cuenta: this.modelHelper.AYBTable,
        DeptoAYB: this.modelHelper.usedDepartment,
        IdCliente: this.modelHelper.selectedChangeClient,
        Apodo: this.modelHelper.alias ? this.modelHelper.alias : undefined,
      };
      this.$swal({
        title: "¿Deseas cambiar la información cliente de esta cuenta?",
        text: "Se aperturara una cuenta al cliente seleccionado",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Cambiar cliente",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Cuentas-cambiarCliente", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then(async (result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.dialogs.dialogChangeCliente = false;
            this.loadData();
          } else {
            this.$swal(
              "Error cambiando cuenta",
              result.value.data.error,
              "error",
            );
          }
        }
      });
    },
    async cambiarMesa() {
      if (!this.modelHelper.toMesa || !this.modelHelper.AYBTable) {
        this.$swal("Error", "Debe seleccionar una mesa de destino.", "error");
        return;
      }
      this.$alert.alertConfirm({
        action: "cambiar",
        obj: "la cuenta de mesa",
        route: "AYB-Cuentas-cambiarMesa",
        data: {
          Mesa: this.modelHelper.toMesa,
          Id: this.modelHelper.AYBTable.id,
          Departamento: this.modelHelper.AYBTable.Departamento,
          DeptoAYB: this.modelHelper.usedDepartment,
        },
        onSuccess: () => {
          this.dialogs.dialogChangeMesa = false;
          this.modelHelper.AYBTable = null;
          this.loadData();
        },
      });
    },
    async cambiarMesero() {
      if (
        !this.modelHelper.AYBTable ||
        !this.modelHelper.AYBTable.Mesero ||
        !this.modelHelper.AYBTable.Mesero.Id
      ) {
        this.$swal("Error", "Debe seleccionar un mesero.", "error");
        return;
      }
      const dataToSend = {
        Departamento: this.modelHelper.AYBTable.Departamento,
        Mesero: this.modelHelper.AYBTable.Mesero.Id,
        Id: this.modelHelper.AYBTable.id,
        DeptoAYB: this.modelHelper.usedDepartment,
      };
      this.$alert.alertConfirm({
        action: "cambiar",
        obj: "el mesero de la cuenta",
        route: "AYB-Cuentas-cambiarMesero",
        data: dataToSend,
        onSuccess: () => {
          this.dialogs.dialogChangeMesero = false;
          this.loadData();
        },
      });
    },
    async eliminarCuenta(cuenta) {
      let datos = {
        Id: cuenta.id,
        DeptoAYB: cuenta.DAYB,
      };
      this.$swal({
        title: "¿Deseas desactivar la cuenta de esta mesa?",
        text: "Se desactivará la cuenta",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Desactivar Cuenta",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Cuentas-desactivarCuenta", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then(async (result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.loadData();
          } else {
            this.$swal(
              "Error desactivando cuenta",
              result.value.data.error,
              "error",
            );
          }
        }
      });
    },
    async cerrarMesa(mesa, deptoId) {
      const cuentas = Array.isArray(mesa?.Cuentas)
        ? mesa.Cuentas.filter((cuenta) => cuenta && cuenta.id)
        : [];

      if (cuentas.length > 0) {
        const cuentasData = cuentas.map((cuenta) => {
          return {
            Id: cuenta.id,
            DeptoAYB: cuenta.DAYB || deptoId,
          };
        });

        this.$alert.alertConfirmAllSequential(
          {
            action: "cerrar",
            obj: "las cuentas de la mesa",
            text: `Se cerrarán definitivamente ${cuentas.length} cuenta(s)asociada(s) a esta mesa.`,
            route: "AYB-Cuentas-desactivarCuenta",
            onSuccess: () => {
              this.loadData();
            },
          },
          cuentasData,
        );
        return;
      }

      const dataToSend = {
        Departamento: deptoId,
        DeptoAYB: deptoId,
        Id: mesa.Contenedor.Id,
      };
      this.$alert.alertConfirm({
        action: "cerrar",
        obj: "la mesa",
        route: "AYB-Mesas-cerrarMesa",
        data: dataToSend,
        onSuccess: () => {
          this.loadData();
        },
      });
    },
    // fin metodos para mesas //

    // inicio cargarData //
    async loadData() {
      this.isLoading = true;
      this.dataPorDepartamento = [];
      try {
        await this.getDepartamentosAB();

        if (this.departamentos.length === 0) {
          console.warn("No se encontraron departamentos.");
          this.isLoading = false;
          return;
        }
        const promesasDeDepartamentos = this.departamentos.map(
          async (depto) => {
            const [areas, contenedores] = await Promise.all([
              this.getAreasByDepto(depto.Id),
              this.getContenedoresByDepto(depto.Id),
            ]);
            const mesasAbiertas = this.processMesasAbiertas(
              areas,
              contenedores,
            );
            if (mesasAbiertas.length === 0) {
              return { ...depto, areasAgrupadas: [] };
            }
            const cuentasPorMesa = await this.getCuentasAbiertasByMesa(
              mesasAbiertas,
            );
            const mesasCompletas = this.getMesasYCuentas(
              mesasAbiertas,
              cuentasPorMesa,
            );
            const areasAgrupadas = this.agruparMesasPorArea(mesasCompletas);
            return { ...depto, areasAgrupadas: areasAgrupadas };
          },
        );
        this.dataPorDepartamento = await Promise.all(promesasDeDepartamentos);
      } catch (error) {
        console.error("Error cargando datos maestros:", error);
      } finally {
        this.isLoading = false;
      }
    },
    // fin cargarData //
  },
  mounted() {
    this.loadData();
  },
};
</script>
